import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { BrandsPage } from './_dashboard.catalog.brands'

export const Route = createFileRoute('/_dashboard/catalog/brands/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: BrandsIndexPage,
})

function BrandsIndexPage() {
  return <BrandsPage selectedId={undefined} />
}
